
import guest_layout from "../guest_layout";
import guest_login_layout from "../guest/guest_login_layout";

export default [
    {
        path: "/",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "home",
                component: () => import("@/guest/Home")
            }
        ]
    },
    {
        path: "/welcome",
        name: "websiteProtection",
        component: () => import("@/guest/websiteAccess")
    },
    {
        path: "/privacy-policy",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "privacypolicy",
                component: () => import("@/guest/privacypolicy")

            }
        ]
    },
      {
        path: "/search-results",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "searchProperty",
                component: () => import("@/guest/searchProperty")

            }
        ]
    },
    {
        path: "/login/google/callback",
        name: "googleCallback",
        component: () => import("@/guest/GoogleCallback"),
    },
    {
        path: "/auth/facebook/callback",
        name: "facebookCallback",
        component: () => import("@/guest/FacebookCallback"),
    },
    {
        path: "/cookies-policy",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "cookiesPolicy",
                component: () => import("@/guest/cookiesPolicy")

            }
        ]
    },
    {
        path: "/termsofservice",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "termsofservice",
                component: () => import("@/guest/termsofservice")

            }
        ]
    },
    {
        path: "/cancellation-and-refund-policy",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "cancellationAndRefundPolicy",
                component: () => import("@/guest/cancellationAndRefundPolicy")

            }
        ]
    },
    {
        path: "/guest-terms-and-conditions",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "guestTermsConditions",
                component: () => import("@/guest/guestTermsConditions")

            }
        ]
    },
    {
        path: "/host-terms-and-conditions",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "hostTermsConditions",
                component: () => import("@/guest/hostTermsConditions")

            }
        ]
    },
    {
        path: "/standard-contractual-clauses",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "standardContractualClauses",
                component: () => import("@/guest/standardContractualClauses")

            }
        ]
    },
    {
        path: "/data-processing-agreement",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "dataProcessingAgreement",
                component: () => import("@/guest/dataProcessingAgreement")

            }
        ]
    },
    {
        path: "/legal-disclaimer",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "legalDisclaimer",
                component: () => import("@/guest/legalDisclaimer")

            }
        ]
    },
    {
        path: "/faq",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "faq",
                component: () => import("@/guest/faqs")

            }
        ]
    },
    // {
    //     path: "/mission",
    //     component: guest_layout,
    //     children: [
    //         {
    //             path: "",
    //             name: "mission",
    //             component: () => import("@/guest/mission")

    //         }
    //     ]
    // },
    {
        path: "/about-us",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "about",
                component: () => import("@/guest/about_us")

            }
        ]
    },
    {
        path: "/contact-us",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "contact",
                component: () => import("@/guest/contact_us")

            }
        ]
    },
    {
        path: "/my_bookings",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "my_bookings",
                component: () => import("@/guest/my_bookings")

            }
        ]
    },
    {
        path: "/add_property",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "add_property",
                component: () => import("@/property/parentComponent")
            }
        ]
    },
    {
        path: "/income_statistics",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "income_statistics",
                component: () => import("@/guest/income_statistics")

            }
        ]
    },
    {
        path: "/user_info",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "user_information",
                component: () => import("@/guest/user_information")

            }
        ]
    },
    // {
    //     path: "/manage_properties",
    //     component: guest_layout,
    //     children: [
    //         {
    //             path: "",
    //             name: "manage_properties",
    //             component: () => import("@/guest/manage_property")

    //         }
    //     ]
    // },
    // {
    //     path: "/property_details",
    //     component: guest_layout,
    //     children: [
    //         {
    //             path: "",
    //             name: "property_details",
    //             component: () => import("@/guest/property_details")
    //         }
    //     ]
    // },
    {
        path: "/property/detail/:id",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "property_detail",
                component: () => import("@/guest/propertyDetail")

            }
        ]
    },
    {
        path: "/invoice/detail/:id",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "invoice_detail",
                component: () => import("@/guest/invoiceDetail")

            }
        ]
    },
    {
        path: "/property/rating/:id",
        component: guest_layout,
        children: [
            {
                path: "",
                name: "property_rating",
                component: () => import("@/guest/RatingReviews")
            }
        ]
    },
    // {
    //     path: "/property/payment",
    //     component: guest_layout,
    //     children: [
    //         {
    //             path: "",
    //             name: "property_payment",
    //             component: () => import("@/guest/payment")
    //         }
    //     ]
    // },
    {
        path: "/property/payment",
        component: guest_layout,
        beforeEnter: (to, from, next) => {
            const user = JSON.parse(localStorage.getItem('user'));
            if (!user) {
                next('/');
            } else {
                next(); // Allow access
            }
        },
        children: [
            {
                path: "",
                name: "property_payment",
                component: () => import("@/guest/payment")
            }
        ]
    },
    {
        path: "/home/login",
        component: guest_login_layout,
        children: [
            {
                path: "",
                name: "guest_login",
                component: () => import("@/guest/Login")
            }
        ]
    },
    {
        path: "/home/signup",
        component: guest_login_layout,
        children: [
            {
                path: "",
                name: "guest_signup",
                component: () => import("@/guest/Register")
            }
        ]
    },
    {
        path: "/forgot-password",
        component: guest_login_layout,
        children: [
            {
                path: "",
                name: "forgot-password",
                component: () => import("@/guest/forgot_password")
            }
        ]
    },
    {
        path: "/reset-password/:token",
        name: "reset-password",
        component: () => import("@/guest/reset_passwords")
    },
    // {
    //     path: "/chat",
    //     component: guest_layout,
    //     children: [
    //         {
    //             path: "",
    //             name: "chat",
    //             component: () => import("@/guest/chat")
    //         }
    //     ]
    // },
    {
        path: "/chat",
        component: guest_layout,
        beforeEnter: (to, from, next) => {
            const user = JSON.parse(localStorage.getItem('user'));
            if (!user) {
                next('/');
            } else {
                next(); // Allow access
            }
        },
        children: [
            {
                path: "",
                name: "chat",
                component: () => import("@/guest/chat"),
            }
        ]
    }
];